import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rent-calculator',
  component: () => import('../../routes/RentCalculator.svelte'),
  card: {
    id: 'rent-calculator',
    title: 'Rent Affordability',
    description: 'Find out how much rent you can afford using the 50/30/20 budgeting rule.',
    icon: 'apartment',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/rent-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Rent Affordability Calculator – How Much Rent Can I Afford?',
    description: 'Free rent affordability calculator using the 50/30/20 budget rule. Calculate how much rent you can afford based on income, debts, and expenses. Perfect for renters and apartment hunters.',
  },
};

export default meta;
